const SectionHeading = ({ id, eyebrow, title, description, align = "center", light = false }) => (
  <div className={`lp-heading text-${align}${light ? " lp-heading--light" : ""}`}>
    {eyebrow && <span className="lp-eyebrow">{eyebrow}</span>}
    <h2 id={id} className="lp-heading__title">{title}</h2>
    {description && <p className="lp-heading__desc">{description}</p>}
  </div>
);

export default SectionHeading;
